import { EnumProducts } from "services/caju/enums/enumProducts";

export const HYBRID_JOURNEY_MIN_EMPLOYEES = 20;
export const HYBRID_JOURNEY_MAX_EMPLOYEES = 49;

export function isHybridJourneyEligible(
  selectedProducts: EnumProducts[],
  employeesNumber?: number | "",
): boolean {
  const isTargetSegment =
    Boolean(employeesNumber) &&
    Number(employeesNumber) >= HYBRID_JOURNEY_MIN_EMPLOYEES &&
    Number(employeesNumber) <= HYBRID_JOURNEY_MAX_EMPLOYEES;

  if (!isTargetSegment) return false;

  const isOnlyPeopleManagement =
    selectedProducts.length === 1 &&
    selectedProducts[0] === EnumProducts.CAJU_CICLOS;

  const hasHealthAndWellness = selectedProducts.includes(
    EnumProducts.CAJU_MAIS,
  );

  return !isOnlyPeopleManagement && !hasHealthAndWellness;
}
